module.exports = __webpack_public_path__ + "static/media/american_express_icon.a187af91.svg";